import { useContext } from 'react';
import StreamContext from 'src/contexts/StreamContext';
console.log('ddd')
const useStream = () => useContext(StreamContext);

export default useStream;
